import { compose, withState, withHandlers, withContext, pure } from 'recompose';
import PropTypes from 'prop-types';

const withSidebarStateAndContext = compose(
  withState('sidebarActive', 'setSidebarActive', false),
  pure,
  withHandlers({
    toggleSidebar: props => active => props.setSidebarActive(active),
  }),
  withContext(
    {
      sidebarActive: PropTypes.bool,
      toggleSidebar: PropTypes.func,
    },
    props => ({
      sidebarActive: props.sidebarActive,
      toggleSidebar: props.toggleSidebar,
    })
  ),
);

export default withSidebarStateAndContext;
